import React, {useState, useContext, useEffect, useRef} from "react";
import Dashview from "../Dashview";
import axios from 'axios';
import {AppContext} from "AppContext";
import Tooltip from 'rc-tooltip';


const OrderSummary = (props) => {

    const { config } = useContext(AppContext);
    const [ open, set_open ] = useState(props.open);
    const [ total_cost_visible, set_total_cost_visible ] = useState(false);
    const [ ship_addr_visible, set_ship_addr_visible ] = useState(false);
    const [ invoice_visible, set_invoice_visible ] = useState(false);
    
    const finishes = [
        { text: "MJF Finish",               value: "MJF_FINISH"},
        { text: "Vapor Smooth",             value: "VAPOR_SMOOTHING"},
        { text: "Black Dye",                value: "BLACK_DYE"},
        { text: "Vapor Smooth / Black Dye", value: "AMT_BLACK_DYE"},
        { text: "Sinter",                   value: "SINTER"},
        { text: "Depowder Only",            value: "DEPOWDER" }
    ];

    const units = [
        { text: "mm", value: "UNITS_MM"},
        { text: "in", value: "UNITS_IN"}
    ];

    useEffect(() => {
        set_open(props.open)
    }, [props.open])

    function imgNotFound(image) {
        image.target.onerror = null;
        image.target.src = "/no_image.png";
        image.target.alt = "No image found placeholder"
        return true;
    }

    function prevent_default(e) {
        e.preventDefault();
    }

    function toggleOpen(args) {
        if (args.defaultPrevented) return;
        if (!window.getSelection().toString()) {
            set_open(previousOpen => !previousOpen);
        }
    }
    
    function on_total_cost_visible_change(args) {
        set_total_cost_visible(!total_cost_visible);
    }

    function on_ship_addr_visible_change(args) {
        set_ship_addr_visible(!ship_addr_visible);
    }

    function on_invoice_visible_change(args) {
        set_invoice_visible(!invoice_visible);
    }

    // const total_cost = props.value.metadata.parts.reduce((acc, curr) => acc + curr.price_total, 0);
    // const ship_address = props.value.Address;
    // const city_state_line = ship_address ? ship_address.city + ", " + ship_address.state + " " + ship_address.zip : "";
    // const address_block = ship_address ? 
    //     [ship_address.name, ship_address.org, ship_address.address_1, ship_address.address_2, city_state_line].filter(Boolean).join("\n") : "";
    // Calculate cost totals and format Total Cost Block
    const amount_surcharge = props.value.Surcharges.reduce((acc, curr) => acc + (curr.unit_price * curr.OrderSurcharge.surcharge_qty), 0.);
    const amount_shipping = props.value.amount_shipping;
    const total_cost = props.value.metadata.parts.reduce((acc, curr) => acc + curr.price_total, 0) +
        (amount_surcharge ?? 0) + (amount_shipping ?? 0) + (props.value.metadata.amount_tax ?? 0);
        
    const show_total_cost_block = props.value.Surcharges.length > 0 || amount_shipping > 0 || props.value.metadata.amount_tax;
    const subtotal_line = "Subtotal: " + props.value.metadata.parts.reduce((acc, curr) => acc + curr.price_total, 0).toFixed(2);
    const surcharge_line = amount_surcharge > 0 ? "\nSurcharge: " + amount_surcharge.toFixed(2) : "";
    const ship_cost_line = amount_shipping > 0 ? "\nShipping: " + amount_shipping.toFixed(2) : "";
    const tax_cost_line = props.value.metadata.amount_tax ? "\nTaxes: " + props.value.metadata.amount_tax.toFixed(2) : "";
    const total_cost_array = [subtotal_line, surcharge_line, ship_cost_line, tax_cost_line];
    
    // Pad each string so the decimal places will vertically align
    const rightmost_period = total_cost_array.reduce((furthest, current) => Math.max(current.replace("\n", "").indexOf("."), furthest), 0);
    const total_cost_block = total_cost_array.map((line => {
        const pad_amount = rightmost_period - line.replace("\n", "").indexOf(".");
        const padding = ":".padEnd(pad_amount + 1, " ");
        return line.replace(":", padding);
    })).join("");

    // Format Address Block
    const ship_address = props.value.Address;
    const city_state_line = ship_address ? ship_address.city + ", " + ship_address.state + " " + ship_address.zip : "";
    const address_block = ship_address ? [
        props.value.shipping_method,
        ship_address.name, 
        ship_address.org, 
        ship_address.address_1, 
        ship_address.address_2, 
        city_state_line,
        ship_address.country
    ].filter(Boolean).join("\n") : "";
        
    // Format Invoice Block
    const invoice_block = "Uploaded Invoice:\n" + props.value.original_invoice;

    return (
        <div className={"rounded-md border width-full mt-4"}>
            <div className={"width-full flex flex-row bg-gray-200 rounded-t p-4 space-x-8"} onClick={toggleOpen}>
                <div className={"flex flex-col"}>
                    <div className={"text-sm"}>Customer:</div>
                    <div className={"font-medium"}>{props.value.Account.company}</div>
                </div>
                <div className={"flex flex-col"}>
                    <div className={"text-sm"}>Items:</div>
                    <div>{props.value.metadata.parts.length}</div>
                </div>
                <div className={"flex flex-col"}>
                    <div className={"text-sm"}>Total Sale:</div>
                    { show_total_cost_block ? 
                    <Tooltip 
                        placement="bottom"
                        visible={total_cost_visible}
                        onVisibleChange={on_total_cost_visible_change}
                        trigger={["click"]}
                        overlay={
                            <p onClick={prevent_default}>{total_cost_block}</p>
                        }
                        overlayInnerStyle={{
                            background: 'white', 
                            color: 'black', 
                            fontFamily: 'monospace, monospace', 
                            fontSize: '1rem', 
                            lineHeight: '1.5rem', 
                            whiteSpace: 'pre'
                        }}
                    >
                        <button onClick={prevent_default} className={"w-fit cursor-pointer underline"}>
                            { total_cost.toFixed(2) }
                        </button>
                    </Tooltip>
                    :
                    <div>{ total_cost.toFixed(2) }</div>
                    }
                </div>
                { props.value.Address &&
                <div className={"flex flex-col"}>
                    <div className={"text-sm"}>Shipped To:</div>
                    <Tooltip 
                        placement="bottom"
                        visible={ship_addr_visible}
                        onVisibleChange={on_ship_addr_visible_change}
                        trigger={["click"]}
                        overlay={
                            <p onClick={ prevent_default }>{address_block}</p>
                        }
                        overlayInnerStyle={{
                            background: 'white', 
                            color: 'black', 
                            fontFamily: 'monospace, monospace', 
                            fontSize: '1rem', 
                            lineHeight: '1.5rem', 
                            whiteSpace: 'pre-line'
                        }}
                    >
                        <button onClick={prevent_default} className={"w-fit cursor-pointer underline"}>
                            { props.value.Address.name || props.value.Address.org || props.value.Address.address_1 }
                        </button>
                        
                    </Tooltip>
                </div>
                }
                { props.value.purchase_order &&
                <div className={"flex flex-col"}>
                    <div className={"text-sm"}>Purchase Order #:</div>
                    { props.value.original_invoice ?
                    <Tooltip
                        placement="bottom"
                        visible={invoice_visible}
                        onVisibleChange={on_invoice_visible_change}
                        trigger={["click"]}
                        overlay={
                            <p onClick={prevent_default}>{invoice_block}</p>
                        }
                        overlayInnerStyle={{
                            background: 'white', 
                            color: 'black', 
                            fontFamily: 'monospace, monospace', 
                            fontSize: '1rem', 
                            lineHeight: '1.5rem', 
                            whiteSpace: 'pre'
                        }}
                    >
                        <button onClick={prevent_default} className={"w-fit cursor-pointer underline 2xl:max-w-xs 2xl:truncate"}>
                            { props.value.purchase_order }
                        </button>
                    </Tooltip> 
                    :
                    <div className="2xl:max-w-xs 2xl:truncate">
                        { props.value.purchase_order }
                    </div>
                    }
                </div>
                }
                { props.value.stripe_status && 
                <div className={"flex flex-col"}>
                    <div className={"text-sm"}>Payment Status:</div>
                    <div className="2xl:max-w-xs 2xl:truncate">
                        { props.value.stripe_status }
                    </div>
                </div>
                }
                <div className={"flex flex-grow flex-col items-end"}>
                    <div className={"flex text-sm"}>Order Id: {props.value.id}</div>
                    <div className={"flex mt-1"}>
                    { props.value.itar &&
                        <div className={"text-sm font-semibold pr-4"}>*ITAR Compliant</div>
                    }
                    {
                        open ?
                        <svg className={"h-5 w-5"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" strokeWidth={1} d="m4.5 18.75 7.5-7.5 7.5 7.5" />
                            <path stroke-linecap="round" stroke-linejoin="round" strokeWidth={1} d="m4.5 12.75 7.5-7.5 7.5 7.5" />
                        </svg>
                        :
                        <svg className={"h-5 w-5"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" strokeWidth={1}  d="m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5" />
                        </svg>
                    }
                    </div>
                </div>
            </div>
            { open &&
                <div className={"width-full bg-white p-4"}>
                    { props.value.metadata.parts.map((item, index) => {
                        return (
                            <div className={index === props.value.metadata.parts.length-1 ? "width-full" : "width-full mb-4 border-b pb-2 border-dashed border-gray-500"} key={index}>
                                <div className={"flex flex-cols space-x-4"}>
                                    <div style={{ minWidth: "96px", width: "96px", height: "96px", minHeight: "96px"}}>
                                    <div ><img src={config.storage.host + "/orders/" + props.value.acctId + "/" + item.snapshot_filename}
                                    onError={ (img) => imgNotFound(img) } alt={"Screenshot of part " + item.original_filename} /></div>
                                    </div>
                                    <div className={"grid grid-cols-5 gap-4 flex-grow"}>
                                        <div>
                                        <div className={"text-sm font-semibold"}>
                                                Model filename:
                                            </div>
                                            <div className={"break-words"}>
                                                {item.original_filename.replaceAll("_", "_\u200B").replaceAll("-", "-\u200B")}
                                            </div>
                                        </div>
                                        <div>
                                            <div className={"text-sm font-semibold"}>
                                                Material:
                                            </div>
                                            <div>
                                                {item.material}
                                            </div>
                                        </div>
                                        <div className={"col-span-3"}>
                                            <div className={"text-sm font-semibold"}>
                                                Finish:
                                            </div>
                                            <div>
                                                { finishes.find((finishType) => finishType.value === item.finish).text }
                                            </div>
                                        </div>
                                        <div>
                                            <div className={"text-sm font-semibold"}>
                                                Volume:
                                            </div>
                                            <div>
                                                {item.volume.toFixed(2)} { units.find((unit) => unit.value === item.units).text }<sup>3</sup>
                                            </div>
                                        </div>
                                        <div>
                                            <div className={"text-sm font-semibold"}>
                                                Price:
                                            </div>
                                            <div>
                                                {item.price_per_component.toFixed(2)}
                                            </div>
                                        </div>
                                        <div>
                                            <div className={"text-sm font-semibold"}>
                                                Quantity:
                                            </div>
                                            <div>
                                                {item.quantity}
                                            </div>
                                        </div>
                                        <div>
                                            <div className={"text-sm font-semibold"}>
                                                Total Cost:
                                            </div>
                                            <div>
                                                {item.price_total.toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {item.comments !== "" &&
                                <div className={"pr-2 pl-2 pt-2"}>
                                    <label className="block">
                                        <div className="text-sm font-semibold">
                                            Special Instructions / Comments:
                                        </div>
                                        <div>
                                            {item.comments.trim().replaceAll("\n", " || ")}
                                        </div>
                                    </label>
                                </div>
                                }
                            </div>
                        )
                    })}
                </div>
            }
        </div>
    )
}

const Content = (props) => {

    const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
    };

    const { config } = useContext(AppContext);
    const [ orders, set_orders ] = useState([]);
    const [ materials, set_materials ] = useState([]);
    const [ loading, set_loading ] = useState(true);
    const [ dateview, set_dateview] = useState(new Date().toLocaleDateString("en-CA")); 
    const [ displayDate, set_displayDate ] = useState(new Date().toLocaleDateString("en-US", options));
    const [ expandedView, set_expandedView ] = useState(true);
    const [ height, set_height ] = useState(0);
    const containerRef = useRef(null);
    const fontSize = parseInt(getComputedStyle(document.documentElement).fontSize);

    useEffect(() => {
        // Retrieve material data from the server:
        const action = async () => {
            try {
                const rxMaterials = await axios.get(config.api.base + '/materials');
                set_materials(rxMaterials.data);
            } catch(x) {
                console.log(x);
            }

        }
        action(config.api.base);

    }, [config.api.base])

    useEffect(() => { 
        // Retrieve all quotes from the server:
        const action = async () => {
            try {
                // Retrieve material data from the server:
                const response = await axios.get(config.api.base + '/orders/ondate/' + dateview); 
                set_loading(false);
                set_orders(response.data);
            } catch(x) {
                console.log(x);
                set_loading(false);
                set_orders([]);
            }

        }
        action();

    }, [config.api.base, displayDate])

    useEffect(() => {
        if (!loading) {
            let getCurrentHeightDiff = setTimeout(() => {
                // adding fontSize * 5 for the header bar, which is 5rem
                set_height(containerRef.current.scrollHeight + fontSize * 5 - window.innerHeight);
            })
            return () => clearTimeout(getCurrentHeightDiff);
        } else {
            set_height(0);
        }
    }, [loading, fontSize, expandedView, orders])

    function onDateChange(args) {
        set_dateview(args.target.value);
    }
    
    function onDatePick(_) {
        let newDate = new Date(dateview).toLocaleDateString("en-US", options);
        if (newDate !== displayDate) {
            set_loading(true);
            set_displayDate(newDate);
        }
    }

    function toggleExpand() {
        set_expandedView(previousView => !previousView);
    }
    

    if (loading) {
        return (
            <div className={"container mx-auto"}>
                <div className={"flex w-full border-b-2 border-solid py-4"}>
                    <div>
                        <span className={"text-3xl"}>
                            Order History Loading...
                        </span>
                    </div>
                </div>
                <div className={"flex flex-col flex-grow w-full h-full justify-center items-center"}>
                    <div className={"mt-48"}>
                        <span className={"text-2xl text-gray-700"}>
                            Loading...
                        </span>
                    </div>
                    <div style={{ width: "240px", height: "240px"}}>
                        <img src={"/loading-transparent.gif"} style={{ height: "100%"}} alt="A loading gif - Many 2D planes moving and intersecting in 3D" />
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className={"container mx-auto"} ref={containerRef}>
                <div className={"flex w-full border-b-2 border-solid py-4"}>
                    <div className={"flex items-end"}>
                        <span className={"text-3xl"}>
                            Order History for {displayDate}
                        </span>
                    </div>
                    <div className={"flex flex-grow justify-end items-center"}>
                        <label className={"pl-2"}>
                            <span className={"text-2xl"}>Change Date to:</span>
                            <input 
                             type="date" 
                             value={dateview} ex
                             onChange={onDateChange} 
                             onFocus={(e) => {e.target.showPicker()}} 
                             onKeyDown={(e) => {e.preventDefault();}} 
                             className={"ml-2 pl-1 text-lg border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"}
                            />
                        </label>
                        <button className={"ml-4 px-5 estimateButton"} onClick={onDatePick}>
                            Go
                        </button>
                    </div>
                </div>
                <div className={"flex flex-row pt-4"}>
                    <div className={"flex flex-grow text-2xl"}>
                        {
                            orders.length ? 
                            orders.length + " order(s) found, " + 
                            orders.reduce(
                                (acc, curr) => acc + curr.metadata.parts.reduce((acc, curr) => acc + curr.price_total, 0), 0
                            ).toLocaleString("en-US", { style: "currency", currency: "USD", currencyDisplay: "narrowSymbol" }) + " total sales:" 
                            : 
                            "No orders for " + displayDate + "."     
                        }
                    </div>
                    {
                        orders.length > 0 &&
                        <div className={"flex"}>
                            <button className="standardButton" onClick={toggleExpand}>
                                {expandedView ? "Collapse All" : "Expand All"}
                            </button>
                        </div>
                    }
                </div>
                <div className="pb-4">
                    { 
                        orders.map((item, index) => {
                            return <OrderSummary value={item} materials={materials} key={index} index={index} open={expandedView}/>
                        })
                    }
                </div>
                { height > 0 &&
                    <div className={"flex pt-2 pb-4 justify-center"}>
                        <button onClick={ () =>  window.scroll({top: 0, behavior: 'smooth'}) } className={"cursor-pointer text-sm text-indigo-500"}>
                            Jump to Top
                        </button>
                    </div>
                }
            </div>
        )
    }
}


const Orders = (props) => {
    return (<Dashview {...props}><Content/></Dashview>);
}

export default Orders;
